<template>
  <div class="columns is-mobile">
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Filter</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="filter" :disabled="loading">
              <option value="all">All</option>
              <option value="future">Upcoming</option>
              <option value="past">Past</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column"></div>
    <div class="column">
      <div class="field">
        <label class="is-size-7 is-uppercase">Sort</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="sort" :disabled="loading">
              <option value="-createdAt">Newest First</option>
              <option value="createdAt">Oldest First</option>
              <option value="name">Name A-Z</option>
              <option value="-name">Name Z-A</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      role: "all",
      active: "all",
      sort: "-createdAt",
      filter: "future"
    };
  },
  computed: {
    loading() {
      let component = this;
      return component.$store.getters["travel/loading"];
    }
  },
  methods: {
    refresh() {
      let component = this;
      component.$store.dispatch("travel/index");
    }
  },
  watch: {
    sort() {
      let component = this;
      component.$store.commit("travel/sort", component.sort);
      component.refresh();
    },
    filter() {
      let component = this;
      component.$store.commit("travel/filter", component.filter);
      component.refresh();
    }
  }
};
</script>
